export const prepareArticles = (articles: any[]) => {
  const sortedAndFilteredArticles = articles.map((article: any) => {
    const { attributes } = article
    const src = attributes?.src?.url
    const alt = attributes?.src?.alternativeText || attributes?.src?.name

    const tags = attributes?.tags?.map((tag: any) => tag?.value)
    const author = attributes?.author

    return {
      id: article?.id,
      attributes: {
        title: attributes?.title,
        content: attributes?.content,
        excerpt: attributes?.excerpt,
        src: {
          data: {
            attributes: {
              url: src,
              alternativeText: alt,
            },
          },
        },
        tags: {
          data: tags?.map((tag: any) => ({
            attributes: {
              value: tag,
            },
          })),
        },
        filterBy: attributes?.filterBy,
        about: attributes?.about,
        slug: attributes?.slug,
        amountVisitors: Number(attributes?.amountVisitors || 0),
        author: {
          data: {
            attributes: {
              title: author?.title,
              name: author?.name,
              role: author?.role,
              avatar: {
                data: {
                  attributes: {
                    ...author.avatar,
                  },
                },
              },
            },
          },
        },
        publishedAt: attributes?.publishedAt,
      },
    }
  })

  return sortedAndFilteredArticles
}
